/**
 * Utility functions for managing localStorage when switching organizations
 */

/**
 * Clears all localStorage data except for preserved user session data
 * Preserves: token, language preference
 * Clears: all other app-specific data that should reset per organization
 */
export const resetLocalStorageForOrganizationSwitch = () => {
  // Store values we want to preserve across organization switches
  const preservedValues = {
    token: localStorage.getItem("token"),
    language: localStorage.getItem("language"),
  }

  // Clear all localStorage
  localStorage.clear()

  // Restore preserved values
  if (preservedValues.token) {
    localStorage.setItem("token", preservedValues.token)
  }
  if (preservedValues.language) {
    localStorage.setItem("language", preservedValues.language)
  }
}

/**
 * Sets new organization user data after clearing localStorage
 * @param {string} userData - The new user data to store
 */
export const setNewOrganizationUser = userData => {
  resetLocalStorageForOrganizationSwitch()
  localStorage.setItem("LogedUser", userData)
}

export default {
  resetLocalStorageForOrganizationSwitch,
  setNewOrganizationUser,
}
